<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :has-buttons="false" />
</template>
<script>
import { get, call } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'AntennaBearingHistorySettings',
  components: { AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules@ANTENNA_BEARING_HISTORY_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@antenna_bearing_history_enabled'),
    moduleEnabler() {
      return {
        name: 'antenna_bearing_history_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.runMigration({ params: { flush: 'create', tables: 'all' } });
      }
    },
  },
  methods: {
    runMigration: call('uke/migrateAntennaBearingHistoryData'),
  },
};
</script>
